import { Card, Button } from 'antd';
import Table, { ColumnsType } from 'antd/lib/table';
import * as Api from 'api';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';

interface DataType {
  key: number;
  camera_name: string;
  IMEI: string;
  data_usage: string;
  cycle_started_at: string;
  cycle_ended_at: string;
}

const columns: ColumnsType<DataType> = [
  {
    title: 'Camera Name',
    dataIndex: 'camera_name',
    key: 'camera_name',
  },
  {
    title: 'IMEI',
    dataIndex: 'IMEI',
    key: 'IMEI',
  },
  {
    title: 'Data Usage',
    dataIndex: 'data_usage',
    key: 'data_usage',
  },
  {
    title: 'Start of Cycle',
    dataIndex: 'cycle_started_at',
    key: 'cycle_started_at',
  },
  {
    title: 'End of Cycle',
    dataIndex: 'cycle_ended_at',
    key: 'cycle_ended_at',
  },
];

const checkDataUnit = (size: number) => {
  if (size === -1) {
    return 'Unlimited';
  }
  let dataString = '0B';
  if (size > 1000000000) {
    const value = (size / 1000000000).toFixed(1);
    dataString = `${value}GB`; // Use template literal instead of concatenation
  } else if (size > 1000000) {
    const value = (size / 1000000).toFixed(1);
    dataString = `${value}MB`; // Use template literal instead of concatenation
  } else if (size > 1000) {
    const value = (size / 1000).toFixed(1);
    dataString = `${value}KB`; // Use template literal instead of concatenation
  } else if (size > 1) {
    dataString = `${size}B`;
  }
  return dataString;
};

const DatausageCycleCard = () => {
  const [data, setData] = useState<DataType[]>([]);

  useEffect(() => {
    loadHistory();
  }, []);

  const loadHistory = () => {
    Api.DATA_USAGE_CYCLE().then((res: any) => {
      const result = JSON.parse(res.text);
      const histories = result.map((item: any, index: number) => ({
        key: index,
        camera_name: item.camera_name,
        IMEI: item.IMEI,
        data_usage: checkDataUnit(item.data_usage),
        cycle_started_at: item.cycle_started_at,
        cycle_ended_at: item.cycle_ended_at,
      }));
      setData(histories);
    });
  };

  const downloadCSV = () => {
    const header = columns.map((col) => col.title).join(',');
    const rows = data
      .map((item) => `${item.camera_name},\t${item.IMEI},${item.data_usage},${item.cycle_started_at},${item.cycle_ended_at}`)
      .join('\n');

    const csvContent = `${header}\n${rows}`;

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', 'data_usage_cycle.csv');
    link.click();
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
        <Button
          type="primary"
          onClick={downloadCSV}
          disabled={!data || data.length === 0}
        >
          Download CSV
        </Button>
      </div>
      <Table columns={columns} dataSource={data} />
    </div>
  );
};

export default DatausageCycleCard;
